<section class="moreInfoSection">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <button class="moreInfoButton" (click)="toggleLinksPanel()">
          <div
            [class]="{
              iconPlus: !linksPanelVisible(),
              iconMinus: linksPanelVisible(),
            }"
          ></div>
          <p>Más información</p>
        </button>
        <div class="linksPanelWrapper" [class.open]="linksPanelVisible()">
        <div class="linksPanel">
        <div class="linksPanelContent">
          <div class="colEquipments">
            <p class="headTitle">Equipo nuevo</p>
            <button class="titleMovil" (click)="togglePanel('equipments')">
              <p>Equipo nuevo</p>
              <div class="iconArrow" [class.iconArrowOpen]="panelMovil()['equipments']"></div>
            </button>
            <div class="dropdownWrapper" [class.open]="panelMovil()['equipments']">
              <div class="dropdownInner">
                <div class="generalLinks">
                  @for (equipment of newEquipments().results; track $index) {
                    <a class="linkEquipment" [routerLink]="'/equipos/' + equipment.slug">{{
                      equipment.name
                    }}</a>
                  }
                  <div class="linkEquipment">&nbsp;</div>
                  <a class="headTitle subOption" routerLink="/usado">Equipo usado</a>
                  <a class="headTitle subOption" routerLink="/blog">Blog</a>
                </div>
              </div>
            </div>
          </div>
          <a class="titleMovil" routerLink="/usado">Equipo usado</a>
          <a class="titleMovil" routerLink="/blog">Blog</a>
          <div class="colBranches">
            <p class="headTitle">Sucursales</p>
            <button class="titleMovil" (click)="togglePanel('branches')">
              <p>Sucursales</p>
              <div class="iconArrow" [class.iconArrowOpen]="panelMovil()['branches']"></div>
            </button>
            <div class="dropdownWrapper" [class.open]="panelMovil()['branches']">
              <div class="dropdownInner">
                <div class="generalLinks">
                  @for (location of locations(); track $index) {
                    <a class="linkEquipment" [routerLink]="'/sucursales/' + location.slug">{{
                      location.name
                    }}</a>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="colSuppliers">
            <p class="headTitle">Clientes</p>
            <button class="titleMovil" (click)="togglePanel('customers')">
              <p>Clientes</p>
              <div class="iconArrow" [class.iconArrowOpen]="panelMovil()['customers']"></div>
            </button>
            <div class="dropdownWrapper" [class.open]="panelMovil()['customers']">
              <div class="dropdownInner">
                <div class="customers">
                  <a
                    class="linkEquipment"
                    href="https://facturadigital.sitsa.com.mx/pfacturaAcceso/LoginSimple.aspx?prtl=000sitsa/Login.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Consulta tu factura</a
                  >
                  <a
                    class="linkEquipment"
                    href="https://clientes.sitsa.com.mx/PortalSAT/#/auth"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Registra tus datos para facturación</a
                  >
                </div>
              </div>
            </div>
            <p class="headTitle">Proveedores</p>
            <button class="titleMovil" (click)="togglePanel('suppliers')">
              <p>Proveedores</p>
              <div class="iconArrow" [class.iconArrowOpen]="panelMovil()['suppliers']"></div>
            </button>
            <div class="dropdownWrapper" [class.open]="panelMovil()['suppliers']">
              <div class="dropdownInner">
                <div class="suppliers">
                  <a
                    class="linkEquipment"
                    href="https://red.cofidi.com.mx/"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Valida tu factura</a
                  >
                  <a class="linkEquipment" routerLink="/validacion" rel="noopener noreferrer"
                    >Tutorial para validación</a
                  >
                  <a
                    class="linkEquipment"
                    href="https://mx.linkedin.com/company/sitsamex"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Bolsa de Trabajo</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</section>
<footer id="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="gridFooter">
          <div class="backSquare">
            <div class="copysGeneral">
              <div class="logoSitsa">
                <div class="contentImage">
                  <img ngSrc="generals/logo-sitsa-blanco.svg" alt="Logo Sitsa" fill />
                </div>
              </div>
              <div class="address">
                <p>
                  © Sitsa {{ currentYear }} Soluciones Integrales para Trituración SAPI de CV •
                  Todos los derechos reservados © Autopista México - Querétaro 3065, Col. Centro
                  Industrial Tlalnepantla, C.P. 54030, Tlalnepantla de Baz, Estado de México.
                </p>
              </div>
              <div class="certifications">
                <p class="schedule">Lunes a viernes 9:00 a.m. - 6:00 p.m.</p>
                <a href="tel:8000074872" aria-label="sitsa teléfono">800 007 4872</a>
                <div class="certificationsLogos">
                  <div class="contentImage">
                    <img class="SRC" ngSrc="/footer/ESR.svg" alt="ESR" fill />
                  </div>
                  <div class="contentImage">
                    <img class="GPTW" ngSrc="/footer/GPTW.svg" alt="GPTW" fill />
                  </div>
                </div>
              </div>
            </div>
            <div class="links">
              @for (legal of legals(); track $index) {
                <a [routerLink]="'/legales/' + legal.slug" class="linksButton">{{ legal.name }}</a>
              }
              <div class="linksButton">
                Línea de denuncia: <a href="tel:8000438422">800 043 8422</a>
              </div>
            </div>
          </div>
          <div class="socialSquare">
            <div class="col1">
              <a
                class="socialButton facebook"
                href="https://www.facebook.com/SitsaMex"
                target="_blank"
                aria-label="facebook"
                ><div class="contentImage">
                  <img ngSrc="/generals/Facebook.svg" alt="icono facebook" fill /></div
              ></a>
              <a
                class="socialButton linkedin"
                href="https://www.linkedin.com/company/sitsamex"
                target="_blank"
                aria-label="linkedin"
                ><div class="contentImage">
                  <img ngSrc="/generals/LinkedIn.svg" alt="icono linkedin" fill /></div
              ></a>
            </div>
            <div class="col2">
              <a
                class="socialButton twitter"
                href="https://twitter.com/sitsamex"
                target="_blank"
                aria-label="x"
                ><div class="contentImage">
                  <img ngSrc="/generals/X.svg" alt="icono x" fill /></div
              ></a>
              <a
                class="socialButton insta"
                href="https://www.instagram.com/sitsamex/"
                target="_blank"
                aria-label="instagram"
                ><div class="contentImage">
                  <img ngSrc="/generals/Instagram.svg" alt="icono instagram" fill /></div
              ></a>
              <a
                class="socialButton youtube"
                href="https://www.youtube.com/c/SitsaMex"
                target="_blank"
                aria-label="youtube"
                ><div class="contentImage">
                  <img ngSrc="/generals/YouTube.svg" alt="icono youtube" fill /></div
              ></a>
            </div>
          </div>
          <a class="contactSquare" href="tel:8000074872" aria-label="sitsa teléfono">
            <div class="contentImage">
              <img ngSrc="/generals/icon-phone-white.svg" alt="icono teléfono" fill />
            </div>
            <div class="phoneNumber">
              <p>800 007 48 72</p>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</footer>
